import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ClientReportDataModel from '../data-models/ClientReport.DataModel';
import { ClientReportSearchFilter } from '../components/tc-admin/client-report/ClientReport.Component';

const getQueryString = ({tenantId}: ClientReportSearchFilter ) => {
    let querystring = '';   

    if(tenantId){
        querystring += `TenantId=${tenantId}`;
    }
    return querystring;
}

export function getClientReportsTable(
    {tenantId}: ClientReportSearchFilter,
    abortSignal: AbortSignal
): Promise<Array<ClientReportDataModel>> {
    const querystring = getQueryString({tenantId});
    return apiGet<Array<ClientReportDataModel>>(`/reports/client-report?${querystring}`, abortSignal);
} 